<template>
  <footer id="main-footer" class="container-fluid">
    <div class="container py-4">
      <div id="DIV_3">
        <a href="#" title="Facebook" id="A_4">
          <font-awesome-icon :icon="['fab', 'facebook-square']" />
        </a>
        <a href="#" title="Twitter" id="A_6">
          <font-awesome-icon :icon="['fab', 'twitter-square']" />
        </a>
        <a href="#" title="Vimeo" id="A_8">
          <font-awesome-icon :icon="['fab', 'vimeo-square']" />
        </a>
        <a href="#" title="RSS" id="A_10">
          <font-awesome-icon :icon="['fas', 'rss-square']" />
        </a>
      </div>
      <ul id="UL_12">
        <li id="LI_13">
          <a href="http://grbaptist.org/" id="A_14">Home</a>
        </li>
        <li id="LI_15">
          <a href="http://grbaptist.org/new-here/" id="A_16">New Here?</a>
        </li>
        <li id="LI_17">
          <a href="https://www.truelife.org" id="A_18">TrueLife</a>
        </li>
        <li id="LI_19">
          <a href="#" id="A_20">Connect</a>
        </li>
        <li id="LI_21">
          <a href="http://grbaptist.org/about/" id="A_22">About</a>
        </li>
        <li id="LI_23">
          <a href="http://grbaptist.org/messages/" id="A_24">Messages</a>
        </li>
        <li id="LI_25">
          <a href="http://grbaptist.org/give/" id="A_26">Give</a>
        </li>
      </ul>
      <div id="DIV_27">
        4525 Stauffer Ave SE, Grand Rapids, MI 49508 | ©2019 Grand Rapids Baptist Church. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'Footer',
  components: {
    FontAwesomeIcon
  }
}
</script>


<style scoped>
#main-footer {
  background-color: rgb(26,26,26)
}

#DIV_3 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    height: 54px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 100%;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 600px 27px;
    transform-origin: 600px 27px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 11px "Open Sans", sans-serif;
    margin: 20px 0px;
    outline: rgb(255, 255, 255) none 0px;
}/*#DIV_3*/

#A_4, #A_6, #A_8, #A_10 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 54px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 54px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 27px 27px;
    transform-origin: 27px 27px;
    caret-color: rgb(255, 255, 255);
    background: rgba(255, 255, 255, 0.2) none repeat scroll 0% 0% / auto padding-box border-box;
    border: 0px none rgb(255, 255, 255);
    border-radius: 2100px 2100px 2100px 2100px;
    font: normal normal 400 normal 21px / 54px "Open Sans", sans-serif;
    margin: 0px 15px;
    outline: rgb(255, 255, 255) none 0px;
}/*#A_4, #A_6, #A_8, #A_10*/

#I_5 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: block;
    height: 54px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 54px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 27px 27px;
    transform-origin: 27px 27px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_5*/


#I_7 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: block;
    height: 54px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 54px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 27px 27px;
    transform-origin: 27px 27px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_7*/

#I_7:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_7:after*/

#I_7:before {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    content: '""';
    cursor: pointer;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 0px 0px;
    transform-origin: 0px 0px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 21px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_7:before*/

#I_9 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: block;
    height: 54px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 54px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 27px 27px;
    transform-origin: 27px 27px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_9*/

#I_9:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_9:after*/

#I_9:before {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    content: '""';
    cursor: pointer;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 0px 0px;
    transform-origin: 0px 0px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 21px FontAwesomeBrands;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_9:before*/

#I_11 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: block;
    height: 54px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 54px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 27px 27px;
    transform-origin: 27px 27px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesome;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_11*/

#I_11:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 54px FontAwesome;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_11:after*/

#I_11:before {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    content: '""';
    cursor: pointer;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 0px 0px;
    transform-origin: 0px 0px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 900 normal 21px / 21px FontAwesome;
    outline: rgb(255, 255, 255) none 0px;
}/*#I_11:before*/

#UL_12 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 100%;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 600px 7px;
    transform-origin: 600px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    margin: 20px 0px;
    outline: rgb(255, 255, 255) none 0px;
    padding: 0px;
}/*#UL_12*/

#LI_13 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 36.7344px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 18.3594px 7px;
    transform-origin: 18.3672px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_13*/

#LI_13:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_13:after*/

#LI_13:before {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: block;
    float: left;
    opacity: 0.35;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    margin: 0px 6.05px 0px 4.95px;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_13:before*/

#A_14, #A_16, #A_18, #A_20, #A_22, #A_24, #A_26 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    letter-spacing: 1px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    text-transform: uppercase;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 0px 0px;
    transform-origin: 0px 0px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#A_14, #A_16, #A_18, #A_20, #A_22, #A_24, #A_26*/

#A_14:after, #A_16:after, #A_18:after, #A_20:after, #A_22:after, #A_24:after, #A_26:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    letter-spacing: 1px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    text-transform: uppercase;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#A_14:after, #A_16:after, #A_18:after, #A_20:after, #A_22:after, #A_24:after, #A_26:after*/

#A_14:before, #A_16:before, #A_18:before, #A_20:before, #A_22:before, #A_24:before, #A_26:before {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    letter-spacing: 1px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    text-transform: uppercase;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#A_14:before, #A_16:before, #A_18:before, #A_20:before, #A_22:before, #A_24:before, #A_26:before*/

#LI_15 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 83.3906px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 41.6875px 7px;
    transform-origin: 41.6953px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_15*/

#LI_15:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_15:after*/

#LI_17 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 70.6562px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 35.3281px 7px;
    transform-origin: 35.3281px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_17*/

#LI_17:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_17:after*/

#LI_19 {
    bottom: 0px;
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    left: 0px;
    position: relative;
    right: 0px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    top: 0px;
    width: 73.3125px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 36.6562px 7px;
    transform-origin: 36.6562px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_19*/

#LI_19:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_19:after*/

#LI_21 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 56.8125px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 28.4062px 7px;
    transform-origin: 28.4062px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_21*/

#LI_21:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_21:after*/

#LI_23 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 78.3125px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 39.1562px 7px;
    transform-origin: 39.1562px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_23*/

#LI_23:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_23:after*/

#LI_25 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    display: inline-block;
    height: 14px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 42.8125px;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 21.4062px 7px;
    transform-origin: 21.4062px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_25*/

#LI_25:after {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    column-rule-color: rgb(255, 255, 255);
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    list-style: none outside none;
    outline: rgb(255, 255, 255) none 0px;
}/*#LI_25:after*/

#DIV_27 {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    height: 14px;
    letter-spacing: 1px;
    text-align: center;
    text-decoration: none solid rgb(255, 255, 255);
    text-size-adjust: 100%;
    width: 100%;
    column-rule-color: rgb(255, 255, 255);
    perspective-origin: 600px 7px;
    transform-origin: 600px 7px;
    caret-color: rgb(255, 255, 255);
    border: 0px none rgb(255, 255, 255);
    font: normal normal 400 normal 11px / 14.3px "Open Sans", sans-serif;
    margin: 20px 0px;
    outline: rgb(255, 255, 255) none 0px;
}/*#DIV_27*/

</style>
